<template>
  <div class="message-details">
    <div class="return-text" @click="LookMessageList">
      <a-icon type="left" />
      <span style="padding-left: 5px">返回</span>
    </div>
    <div class="details-title">
      <div class="mesage-list-left">
        <img src="@/assets/image/mesage-1.png" class="mesage-icon" alt="" v-if="messageObj.state==1&&messageObj.type==0">
        <img src="@/assets/image/mesage-3.png" class="mesage-icon" alt="" v-if="messageObj.state==0&&messageObj.type==0">
      </div>
      <div class="mesage-list-center">
        <span class="mesage-content" :style="{color: messageObj.state==0?'' :'#888888'}">{{ messageObj.messageTitle }}</span>
        <span class="mesage-time">{{ messageObj.createTime }}</span>
      </div>
    </div>
    <div class="content-text">
      <span :style="{color: messageObj.state==0?'' :'#888888'}">{{ messageObj.messageInfo }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'messageDetails',
  data () {
    return {

    }
  },
  props: {
    messageObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    console.log(this.messageObj)
  },
  methods: {
    LookMessageList () {
      this.$emit('LookMessageList')
    }
  }
}
</script>
<style lang="scss">
.message-details {
  padding: 0 25px;
  .return-text {
    font-size: 16px;
    color: #555555;
    cursor: pointer;
    padding-bottom: 10px;
  }
  .details-title {
    width: 100%;
    min-height: 86px;
    padding: 18px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #eeeeee;
    .mesage-list-left {
      width: 72px;
      .mesage-icon {
        display: inline-block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    .mesage-list-center {
      flex: 1;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      .mesage-time {
        color: #888888;
        font-size: 12px;
      }
    }
    .mesage-list-right {
      width: 124px;
      display: flex;
      align-items: center;
      .mark {
        display: inline-block;
        width: 70px;
        height: 26px;
        background-color: rgba(253, 86, 33, 0.1);
        font-size: 12px;
        color: #fd5621;
        line-height: 26px;
        text-align: center;
      }
    }
  }
  .content-text {
    font-size: 14px;
    color: #555555;
    padding: 50px 70px;
  }
}
</style>